module.exports = __webpack_public_path__ + "img/cv-icon.40a1781a.svg";